<div class="w-full max-w-sm p-4 bg-white border border-gray-200 rounded-lg shadow sm:p-6 md:p-8">
  <!--<label>Media selector</label>-->
  
    <!--<div *ngIf="fileURL">
      <img class="h-96 md:h-auto md:w-48" [src]="fileURL" alt="">
    </div>-->
  <div>
    <div>
      <button type="submit" class="w-full text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
          (click)="pickGallery()">
        Select in gallery
      </button>
    </div>
    <div>
      <image-uploader [activeColor]="'orangered'" [baseColor]="'lightgray'" [maxFileSizeMb]="15"
        [imageUrl]="fileURL"
        [progress]="progress" (fileUpdated)="handleFileUpdated($event)"></image-uploader>
    </div>
  </div>
</div>